<template>
  <div class="main-body">
    <div class="header">已通过志愿队伍</div>
    <div class="out">


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="名称"  fixed></el-table-column>

        <el-table-column prop="loginName" label="登录账号" ></el-table-column>
        <el-table-column prop="phone" label="手机号" ></el-table-column>
        <el-table-column prop="address" label="地址" ></el-table-column>

        <el-table-column prop="createTime" :formatter="getCreateTime" label="申请时间" ></el-table-column>

        <el-table-column prop="statsu" label="状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalAdd:false,
      showModalEdit:false,

      th:0,

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight+50;
  },
  components:{

  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+50;
    },
  },
  methods:{

    getCreateTime(row) {
      return timefilters(row.createTime);
    },

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'VolunteerTeam/GovPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          status:-1,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },


  }
}
</script>

<style scoped>

</style>
